var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:{highlight: _vm.data.highlight},on:{"click":_vm.listen__div__onclick}},[_vm._v(" "+_vm._s(_vm.data.text)+" "),_c('q-tooltip',{attrs:{"anchor":"bottom middle","self":"top middle"}},[_vm._v("id: "+_vm._s(_vm.data.id)+", prob: "+_vm._s(_vm.data.prob.toFixed(3)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }